import { AxiosResponse } from 'axios';
import { $api } from '@partnerka-front/api';
import { AdsTemplateDto } from '@partnerka-front/types';

const basePath = '/ads_template';

export async function getAdsTemplate(): Promise<AxiosResponse<AdsTemplateDto[]>> {
  return $api.get(`${basePath}/`);
}
